import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'app/core/services/auth.service';
import { UserDTO } from 'app/core/dtos/auth.dto';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent implements OnInit {
  userMenuItems: MenuItem[] = [];
  userName = '';
  userInitials = '';
  currentUser: UserDTO | null = null;

  constructor(private authService: AuthService) {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.currentUser = user;
        this.userName = user.fullName;
        this.userInitials = this.getInitials(user.fullName);
      }
    });
  }

  ngOnInit() {
    this.setupMenuItems();
  }

  private getInitials(fullName: string): string {
    return fullName
      .split(' ')
      .map(n => n[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }

  private setupMenuItems() {
    this.userMenuItems = [
      {
        label: 'Sair',
        icon: 'logout',
        command: () => {
          this.authService.logout();
        },
      },
    ];
  }
}
